import React from 'react'
import injectSheet from 'react-jss'
import Slider from 'components/Slider'
import Button from 'components/apps/Button'
import { FormattedMessage } from 'react-intl'

const styles = theme => ({
  table: {
    width: '100%',
    marginBottom: theme.base.spacing,
  },
  sliderCell: {
    width: '70%',
    padding: theme.base.spacing / 2,
  },
  durationCell: {
    width: '10%',
    padding: theme.base.spacing / 2,
    textAlign: 'center'
  },
  buttonCell: {
    padding: theme.base.spacing / 2,
    verticalAlign: 'top',
  },
  result: {
    marginTop: 36,
    fontSize: 36,
    textAlign: 'center'
  },
  label: {
    display: 'none',
    '@media (min-width: 600px)': {
      display: 'inline'
    }
  }
})

class App extends React.Component {
  state = {
    entries: [
      { id: 1, value: 2 },
      { id: 2, value: 4 },
      { id: 3, value: 6 },
      { id: 4, value: 1 },
    ]
  }

  changeEntryValue = (id, value) => {
    this.setState({
      entries: this.state.entries.map(entry => {
        if (entry.id === id) {
          return { ...entry, value }
        } else {
          return entry
        }
      })
    })
  }

  addEntry = () => {
    const id = Math.max(...this.state.entries.map(e => e.id)) + 1
    this.setState({
      entries: [...this.state.entries, { id, value: 1 }]
    })
  }

  removeEntry = (id) => {
    const { entries } = this.state
    const index = entries.findIndex(e => e.id === id)
    const left = entries.slice(0, index)
    const right = entries.slice(index + 1, entries.length)
    this.setState({
      entries: left.concat(right)
    })
  }

  calculate = () => {
    const { entries } = this.state
    return entries.reduce((sum, e) => (sum + e.value), 0) / entries.length
  }

  render() {
    const { classes } = this.props
    const { entries } = this.state

    return (
      <div>
        <table className={classes.table}>
          <tbody>
            {entries.map(({ id, value }) => (
              <tr key={id}>
                <th scope="row"><span className={classes.label}><FormattedMessage id="failure" /></span> {id}.</th>
                <td className={classes.sliderCell}>
                  <Slider className={classes.slider} min={1} max={24} dots value={value} onChange={v => this.changeEntryValue(id, v)} />
                </td>
                <td className={classes.durationCell}>{value}h</td>
                <td className={classes.buttonCell}><Button onClick={e => this.removeEntry(id)} block>-</Button></td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr>
              <td colSpan={3}>
                <div className={classes.result}>
                  <strong>MTTR</strong> = {this.calculate().toFixed(2)}h
                </div>
              </td>
              <td className={classes.buttonCell}><Button onClick={this.addEntry} block>+</Button></td>
            </tr>
          </tfoot>
        </table>

      </div>
    )
  }
}

export default injectSheet(styles)(App)
